import { useState, useEffect } from 'react';
import { isAndroid, isTablet } from 'react-device-detect';
import { isNotStandaloneMobilePWA, isStandalonePWA } from '../../../utils/mobileSupported';

const leaderBoardImageSize = {
  width: 1152,
  height: 949,
};

export default function useLeaderBoardTableSizeCalculator(scaleRef) {
  const [containerStyle, setContainerStyle] = useState({
    scale: 1,
    marginTop: 0,
    opacity: 0,
  });

  useEffect(() => {
    const updateScale = () => {
      if (!scaleRef.current) return;

      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;
      const { height, width } = scaleRef.current.getBoundingClientRect();
      const ratio = width / height;

      const minRatio = 1.25;
      const maxRatio = 2.37;
      const minScale = 0.35;
      const maxScale = 0.98;

      let scale = 1;
      if (ratio > 2.1) {
        scale = 0.53;
      } else {
        const clampedRatio = Math.min(Math.max(ratio, minRatio), maxRatio);
        const normalized = (clampedRatio - minRatio) / (maxRatio - minRatio);
        scale = maxScale - normalized * (maxScale - minScale);
      }

      if (isNotStandaloneMobilePWA && !isTablet) {
        scale = windowHeight < 600 ? (isAndroid ? 0.75 : 0.85) : windowHeight < 650 ? 0.9 : windowHeight < 700 ? 1 : windowHeight < 750 ? 1.02 : 0.97;
      }

      const imgRatio = leaderBoardImageSize.width / leaderBoardImageSize.height;
      let renderedHeight;

      if (imgRatio > ratio) {
        renderedHeight = width / imgRatio;
      } else {
        renderedHeight = height;
      }

      let marginTopMultiplier = 0.29;
      if (windowWidth > 1750 && windowHeight < 1000) marginTopMultiplier = 0.26;
      if (windowWidth < 1200 && windowHeight < 800) marginTopMultiplier = 0.3;
      if (ratio > 1.9 && scale < 0.7) marginTopMultiplier = 0.15;
      if (isNotStandaloneMobilePWA && !isTablet) {
        marginTopMultiplier = windowHeight < 600 ? 0.25 : windowHeight < 650 ? 0.27 : windowHeight < 750 ? 0.3 : 0.3;
      }
      if(isStandalonePWA && !isTablet) marginTopMultiplier = isAndroid ? 0.22 : 0.25;
      const marginTop = Math.max(0, (height - renderedHeight) / 2 + renderedHeight * marginTopMultiplier);

      setContainerStyle({
        opacity: 1,
        scale: parseFloat(scale.toFixed(6)),
        marginTop: parseFloat(marginTop.toFixed(2)),
      });
    };

    updateScale();

    const observer = new ResizeObserver(updateScale);
    observer.observe(scaleRef.current);

    return () => observer.disconnect();
  }, [scaleRef]);

  return { containerStyle };
}

